module.exports = __webpack_public_path__ + "img/logo2.8e923b1a.png";